<template>
  <div class="flex flex-col h-full min-h-full">
    <public-announcement :is-fixed="true" />
    <invitation-notifications v-if="currentUser.id" />
    <div class="template-library__content-wrapper">
      <OnboardingV3BackArrow />
      <div class="relative flex w-full mb-4 border-b border-secondary-20" v-show="!isSearching">
        <div class="flex-grow">
          <page-breadcrumb
            category="workspace"
            :text="'Personal'"
            title="Templates"
            :noBorder="true"
          />
        </div>
        <div class="flex-none" v-if="showPublicCommunity">
          <div>
            <!-- desktop publish presentation button -->
            <aha-button
              class="m-2 mt-4 publish-presentation-btn"
              size="md"
              @click="handleOpenModalPublishPresentations()"
            >
              <span>Publish my own</span>
            </aha-button>
            <!-- mobile publish presentation button -->
          </div>
        </div>
      </div>
      <CategoryList :category-id="null" v-if="!isSearching" />
      <div
        v-if="!isEURegion"
        v-show="isSearching"
      >
        <SwitchTabSearch />
      </div>

      <!-- Loading New: with ab test merge search box-->
      <div
        v-if="currentUser.id"
        :class="{
          'flex-grow flex items-center justify-center mr-4 ml-4 md:px-6': templatesLoading
        }"
      >
        <template v-if="templatesLoading">
          <InlineLoader :additionalClasses="'-mt-8'" />
        </template>
      </div>
      <template-not-found
        v-if="!isLoadingTemplates && (templatesError ||
          !templateCategories || templateCategories.length === 0)"
      />

      <TemplateSearchNoDataMergeSearch
        v-show="!templatesLoading"
        v-if="noResult && isSearching"
        :keyword="searchText"
        @request="clearSearch()"
      />
      <div class="mt-10" v-if="isLoadingTemplates && !templateCategories">
        <TemplateSliderSkeleton class="mb-24" />
        <TemplateSliderSkeleton class="mb-24" />
        <TemplateSliderSkeleton class="mb-24" />
        <TemplateSliderSkeleton />
      </div>
      <div
        class="templates"
        v-if="
          templateCategories
            && templateCategories.length > 0
            && filteredPresentations.length === 0
            && !noResult
            && !isSearching
        "
      >
        <div
          class="template-container_item mb-4 slider __slider"
        >
          <h2 class="title-template-type mb-4 text-lg">
            <span class="icon-template-type"><img :src="require('@/assets/images/icon/star.svg')"></span>AhaSlides Pick
          </h2>
          <div
            v-if="!isMobile"
            :class="
              [
                `slider __prev --ahaslides-pick`,
                {
                  hidden: isLoadingTemplateAdminPicked
                }
              ]"
            @click="trackSliderBtn('Back')"
          >
            <aha-icon
              width="12"
              height="18"
              viewBox="0 0 8 14"
              name="arrow-no-tail"
              class="transform rotate-180"
            />
          </div>
          <div
            v-if="!isMobile"
            :class="
              [
                `slider __next --ahaslides-pick`,
                {
                  hidden: isLoadingTemplateAdminPicked
                }
              ]"
            @click="trackSliderBtn('Next')"
          >
            <aha-icon
              width="12"
              height="18"
              viewBox="0 0 8 14"
              name="arrow-no-tail"
            />
          </div>
          <TemplateSliderSkeleton v-if="isLoadingTemplateAdminPicked" />
          <div
            v-if="isMobile && !isLoadingTemplateAdminPicked
              && templateAdminPickedForMobileMini.length > 0"
          >
            <TemplateCardV3
              v-for="presentation in templateAdminPickedForMobileMini"
              :key="`mobile-template-admin-pick-${presentation.id}`"
              :presentation="presentation"
              class="template-library"
              where="AhaSlides Pick"
              templateLocation="template library"
            />
          </div>
          <div>
            <span
              v-if="isMobile && !showLoadMoreAdminPicked"
              class="title-template-see-more"
              @click="showLoadMoreAdminPicked = true"
            >
              See more
            </span>
          </div>

          <div
            v-if="isMobile && showLoadMoreAdminPicked && !isLoadingTemplateAdminPicked
              && templateAdminPickedForMobileFull.length > 0"
          >
            <TemplateCardV3
              v-for="presentation in templateAdminPickedForMobileFull"
              :key="`mobile-template-admin-pick-${presentation.id}`"
              :presentation="presentation"
              class="template-library"
              where="AhaSlides Pick"
              templateLocation="template library"
            />
          </div>

          <swiper
            v-if="!isMobile && !isLoadingTemplateAdminPicked
              && templateAdminPicked.length > 0"
            :ref="`swiper-main`"
            :autoUpdate="true"
            :options="getSliderOptions({ folderId: 'ahaslides-pick', folderName: 'AhaSlides Pick' })"
          >
            <swiper-slide
              class="swiper-slide__template-library"
              v-for="presentation in templateAdminPicked"
              :key="`template-admin-pick-${presentation.id}`"
            >
              <TemplateCardV3
                :presentation="presentation"
                class="template-library"
                where="AhaSlides Pick"
                templateLocation="template library"
              />
            </swiper-slide>
          </swiper>
        </div>
        <div class="template-container_item slider __slider" v-if="!isEURegion">
          <h2 class="title-template-type mb-4 text-lg">
            <span class="icon-template-type"><img :src="require('@/assets/images/icon/fire-alt.svg')"></span>Newly Added
          </h2>
          <div
            v-if="!isMobile"
            :class="{
              'slider __prev --newly-added': true,
              hidden: isLoadingNewlyAdded,
            }"
            @click="trackSliderBtn('Back')"
          >
            <aha-icon name="arrow-no-tail" class="transform rotate-180" />
          </div>
          <div
            v-if="!isMobile"
            :class="{
              'slider __next --newly-added': true,
              hidden: isLoadingNewlyAdded,
            }"
            @click="trackSliderBtn('Next')"
          >
            <aha-icon name="arrow-no-tail" />
          </div>
          <div
            v-if="isMobile && !isLoadingNewlyAdded
              && newlyAddedCommunityTemplatesForMobileMini.length > 0"
          >
            <TemplateCardV3
              v-for="presentation in newlyAddedCommunityTemplatesForMobileMini"
              :key="`mobile-template-newly-added-${presentation.id}`"
              :presentation="presentation"
              class="template-library"
              where="Newly added"
              templateLocation="template library"
            />
          </div>
          <div>
            <span
              v-if="isMobile && !showLoadMoreNewlyAdded"
              class="title-template-see-more title-template-see-more__newly-added"
              @click="showLoadMoreNewlyAdded = true"
            >
              See more
            </span>
          </div>

          <div
            v-if="isMobile && showLoadMoreNewlyAdded && !isLoadingNewlyAdded
              && newlyAddedCommunityTemplatesForMobileFull.length > 0"
          >
            <TemplateCardV3
              v-for="presentation in newlyAddedCommunityTemplatesForMobileFull"
              :key="`mobile-template-newly-added-${presentation.id}`"
              :presentation="presentation"
              class="template-library"
              where="Newly added"
              templateLocation="template library"
            />
          </div>

          <div
            v-if="!isMobile"
            :class="{
              'slider __next --newly-added': true,
              hidden: isLoadingNewlyAdded,
            }"
            @click="trackSliderBtn('Next')"
          >
            <aha-icon name="arrow-no-tail" />
          </div>
          <TemplateSliderSkeleton v-if="!isMobile && (isLoadingNewlyAdded || getNewlyAddedError)" />
          <swiper
            ref="swiper-newly-added"
            v-else
            :autoUpdate="false"
            :options="getSliderOptions({ folderId: 'newly-added', folderName: 'Newly added' })"
            v-show="!isMobile && newlyAddedCommunityTemplatesQualified
              && newlyAddedCommunityTemplatesQualified.length > 0"
          >
            <swiper-slide
              class="swiper-slide__template-library"
              v-for="presentation in newlyAddedCommunityTemplatesQualified"
              :key="presentation.id"
            >
              <TemplateCardV3
                :presentation="presentation"
                class="template-library"
                where="Newly added"
                templateLocation="template library"
              />
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="!isMobile">
          <div
            v-for="category in templateCategories"
            :key="category.folderId"
            class="template-container_item mb-4 slider __slider"
          >
            <div class="title-template-category-container">
              <h2 class="title-template-type title-item-template-category mb-4 text-lg">
                {{ category.folderName }}
              </h2>
              <a
                :href="mappingLinkSeeAll[category.folderId] ? mappingLinkSeeAll[category.folderId] : 'https://presenter.ahaslides.com/apps/template-library'"
                target="_blank"
                class="title-template-see-all"
                @click="trackingSeeAll(category.folderName)"
              >
                See all
              </a>
            </div>
            <TemplateSliderSkeleton v-if="isLoadingTemplates" />
            <div class="container-template-category">
              <TemplateCardCategoryV3
                v-for="presentation in category.presentations"
                :key="category.folderId +'_' +presentation.id"
                :presentation="presentation"
                :where="category.folderName"
                class="template-category-item template-library"
              />
            </div>
          </div>
        </div>
        <div v-if="isMobile" class="template-container_item template-container_item_category">
          <div
            v-for="category in templateCategories"
            :key="category.folderId"
            class="mb-4 slider __slider template-category-item"
          >
            <div class="title-template-category-container">
              <h2 class="mb-4 text-lg title-template-type">
                {{ category.folderName }}
              </h2>
              <a
                :href="mappingLinkSeeAll[category.folderId] ? mappingLinkSeeAll[category.folderId] : 'https://presenter.ahaslides.com/apps/template-library'"
                class="title-template-see-all"
                target="_blank"
                @click="trackingSeeAll(category.folderName)"
              >
                See all
              </a>
            </div>
            <TemplateSliderSkeleton v-if="isLoadingTemplates" />
            <swiper
              v-if="!isLoadingTemplates
                && category.presentations && category.presentations.length > 0"
              :ref="`swiper-main`"
              :autoUpdate="false"
              :options="getSliderOptions(category)"
            >
              <swiper-slide
                v-for="presentation in category.presentations"
                :key="`${presentation.id} - ${category.id}`"
              >
                <TemplateCardCategoryV3
                  :presentation="presentation"
                  :where="category.folderName"
                  templateLocation="template library"
                  class="template-library"
                />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <div
        class="mt-8 templates"
        v-show="!isLoadingTemplates && !templatesLoading"
        v-if="filteredPresentations && filteredPresentations.length > 0"
      >
        <div class="templates-container">
          <TemplateCard
            class="mb-6"
            v-for="presentation in filteredPresentations"
            :key="presentation.id"
            :presentation="presentation"
          />
        </div>

        <div v-if="isLoadmore" class="w-full mb-4 text-center">
          <aha-button @click="loadMore" :submitting="isLoadingMore" :disabled="isLoadingMore">
            Load more...
          </aha-button>
        </div>
      </div>
    </div>
    <ModalPublishPresentations
      @hide="handleCloseModalPublishPresentations()"
      v-if="isModalPublishPresentationsVisible"
      :presentations="notYetPublishPresentations"
      :total="numberOfPresentations"
    />
    <TemplatePreviewPopup
      v-if="previewPopup"
      @hide="hidePreviewPopUp()"
      :presentationShareCode="previewShareCode"
    />
  </div>
</template>

<script>
import _ from 'lodash'

// components
import {
  mapState, mapActions, mapGetters,
} from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import * as Sentry from '@sentry/vue'
import TemplateCard from '@/components-v2/common/template-library/TemplateCard.vue'
import TemplateCardV3 from '@/components-v2/common/template-library/TemplateCardV3.vue'
import TemplateCardCategoryV3 from '@/components-v2/common/template-library/TemplateCardCategoryV3.vue'
import TemplateNotFound from '@/components-v2/common/template-library/TemplateNotFound.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import PageBreadcrumb from '../common/page-breadcrumb/PageBreadcrumb.vue'
import SwitchTabSearch from '@/components-v2/template/SwitchTabSearch.vue'
import TemplateSearchNoDataMergeSearch from '../common/template-library/TemplateSearchNodataMergeSearch.vue'
import ModalPublishPresentations from '../modals/PublishPresentations.vue'
import InlineLoader from '@/components-v2/common/loading/InlineLoader.vue'
import TemplateSliderSkeleton from './TemplateSliderSkeleton.vue'
import OnboardingV3BackArrow from '@/components-v2/common/onboarding/OnboardingV3BackArrow.vue'
import TemplatePreviewPopup from '@/components-v2/template/TemplatePreviewPopup.vue'
import CategoryList from '@/components-v2/template/CategoryList.vue'

// utils
import utils from '@/util'
import SearchApi from '@/api/search'
import CommunityApi from '@/api/community'
import Config from '@/config'
import constants from '@/constant'
import EventBus from '@/eventBus'

import 'swiper/css/swiper.css'

export default {
  components: {
    TemplateCard,
    TemplateCardV3,
    TemplateCardCategoryV3,
    PageBreadcrumb,
    TemplateNotFound,
    PublicAnnouncement,
    InvitationNotifications,
    SwitchTabSearch,
    TemplateSearchNoDataMergeSearch,
    ModalPublishPresentations,
    InlineLoader,
    Swiper,
    SwiperSlide,
    TemplateSliderSkeleton,
    OnboardingV3BackArrow,
    TemplatePreviewPopup,
    CategoryList,
  },
  data() {
    return {
      searchText: '',
      filteredPresentations: [],
      noResult: false,
      page: 1,
      isLoadingMore: false,
      isLoadmore: false,
      limit: 20,
      templatesLoading: false,
      isModalPublishPresentationsVisible: false,
      notYetPublishPresentations: [],
      numberOfPresentations: 0,
      clickingToScroll: null,
      imageObserver: null,
      previewPopup: false,
      previewShareCode: '',
      showLoadMoreAdminPicked: false,
      showLoadMoreNewlyAdded: false,
      mappingLinkSeeAll: {
        13502: 'https://presenter.ahaslides.com/apps/template-library/category/15',
        13400: 'https://presenter.ahaslides.com/apps/template-library/category/16',
        13412: 'https://presenter.ahaslides.com/apps/template-library/category/21',
        999999999: 'https://presenter.ahaslides.com/apps/template-library/category/19',
      },
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),
    ...mapGetters('presentationTemplates', [
      'templateAdminPicked',
      'templateAdminPickedForMobileFull',
      'templateAdminPickedForMobileMini',
      'newlyAddedCommunityTemplatesForMobileMini',
      'newlyAddedCommunityTemplatesForMobileFull',
      'templateCategories',
      'isLoadingTemplates',
      'isLoadingTemplateAdminPicked',
      'trendingTemplates',
      'templatesError',
      'newlyAddedCommunityTemplates',
      'isLoadingNewlyAdded',
      'getNewlyAddedError',
      'getTemplateAdminPickedError',
    ]),

    isMobile() {
      return window.innerWidth < 1024
    },

    isEURegion() {
      return Config.region === constants.euRegion
    },
    isSearching() {
      return this.$route.query.q
    },
    showPublicCommunity() {
      if (!this.currentUser.email || Config.region === constants.euRegion
        || this.currentUser.isDisablePublicTemplate) {
        return false
      }
      return true
    },
    newlyAddedCommunityTemplatesQualified() {
      // const ignoreNames = []
      // const whiteList = ['General Knowledge Quiz']
      // this.templateCategories.forEach((folder) => {
      //   folder.presentations.forEach((presentation) => {
      //     ignoreNames.push(presentation.name)
      //   })
      // })
      // return this.newlyAddedCommunityTemplates.filter((presentation) => {
      //   return (!ignoreNames.includes(presentation.name) || whiteList.includes(presentation.name))
      // })
      return this.newlyAddedCommunityTemplates
    },
  },
  watch: {
    $route: function handleChangeRoute(newRoute) {
      if (newRoute.name === 'TemplateLibrary'
        && newRoute.query.q) {
        // Reset value and queries input
        this.searchText = newRoute.query.q
        this.handleInputChanged()
      } else {
        // Set blank to reload categories, trending default template
        this.filteredPresentations = []
        this.noResult = false
        this.$nextTick(this.initLazyLoad)
      }
    },
    filteredPresentations: function handleChangeFilteredPresentations(filteredPresentations) {
      if (filteredPresentations.length) {
        this.$nextTick(this.initLazyLoad)
      }
    },
    templateCategories: function handleChangeTemplateCategories(templateCategories) {
      if (templateCategories.length) {
        this.$nextTick(this.initLazyLoad)
      }
    },
    newlyAddedCommunityTemplates: function handleUpdate(newlyAddedCommunityTemplates) {
      if (newlyAddedCommunityTemplates.length) {
        this.$nextTick(this.initLazyLoad)
      }
    },
  },
  async mounted() {
    await this.getTemplatesAdminPickedAction()
    await this.getTemplatesAction()
    await this.getNewlyAddedAction()
    this.triggerQuerySearch()
    this.triggerPreviewPopUp()
    EventBus.$on('update-library-after-published', (template) => {
      if (template.customThumbnailImage === '_blank') {
        delete template.customThumbnailImage
      }
      this.updatePublishedTemplateInList(template)
    })
  },
  destroyed() {
    EventBus.$off('update-library-after-published')
  },
  unmounted() {
    this.imageObserver.disconnect()
  },
  methods: {
    ...mapActions('presentationTemplates', [
      'getTemplatesAction',
      'getNewlyAddedAction',
      'getTemplatesAdminPickedAction',
      'updateNewlyAddedAfterPublishAction']),
    initLazyLoad() {
      // if (this.imageObserver) {
      //   this.imageObserver.disconnect()
      // }
      // const imageContainers = Array.from(document.querySelectorAll('.template-thumbnail.has-thumbnail'))
      // if ('IntersectionObserver' in window) {
      //   this.imageObserver = new IntersectionObserver((entries) => {
      //     entries.forEach((entry) => {
      //       if (entry.isIntersecting) {
      //         const image = entry.target.querySelector('.thumbnail-image-with-skeleton')
      //         image.src = image.dataset.src
      //         this.imageObserver.unobserve(image)
      //       }
      //     })
      //   })
      //   imageContainers.forEach((img) => this.imageObserver.observe(img))
      // } else {
      //   imageContainers.forEach((container) => {
      //     const img = container.querySelector('.thumbnail-image-with-skeleton')
      //     img.src = img.dataset.src
      //   })
      // }
    },
    trackSliderBtn(type) {
      this.clickingToScroll = type
    },
    handleInputChanged: _.debounce(async function handleInputChanged() {
      if (!this.templateCategories || !this.searchText) {
        this.filteredPresentations = []
        this.noResult = false
        this.page = 1
        this.isLoadingMore = false
        this.isLoadmore = false
        return
      }
      this.isLoadingMore = false
      this.isLoadmore = false
      this.page = 1
      this.templatesLoading = true // abtestmergesearch loading flag.
      this.handleSearchPresentation()
    }, 300),

    async handleSearchPresentation() {
      const payload = {
        q: this.searchText,
        page: this.page,
        pageSize: this.limit,
      }

      try {
        const resp = await SearchApi.searchPresentation(payload)
        if (!this.searchText) return
        if (this.isLoadingMore) {
          this.filteredPresentations = this.filteredPresentations.concat(resp.body.presentations)
        } else {
          this.filteredPresentations = resp.body.presentations
        }
        if (resp.body.presentations.length < this.limit) {
          this.isLoadmore = false
        } else {
          this.page++
          this.isLoadmore = true
        }
        utils.gaTrackEvent(constants.gaCategories.TEMPLATE_LIBRARY, 'Search Template', null, null, {
          query: this.searchText,
          showingCount: this.filteredPresentations.length,
        })
      } catch (e) {
        Sentry.captureException(e)
      }
      this.isLoadingMore = false
      this.noResult = this.filteredPresentations.length === 0
      this.templatesLoading = false // abtestmergesearch loading flag.
    },

    triggerPreviewPopUp() {
      if (this.$route.query.preview && this.$route.query.preview.length > 1) {
        this.previewPopup = true
        this.previewShareCode = this.$route.query.preview
      }
    },

    triggerQuerySearch() {
      if (this.$route.query.q && this.$route.query.q.length > 1) {
        this.searchText = this.$route.query.q
        if (!this.searchText) {
          this.filteredPresentations = []
          this.noResult = false
          this.page = 1
          this.isLoadingMore = false
          this.isLoadmore = false
          return
        }
        this.isLoadingMore = false
        this.isLoadmore = false
        this.page = 1
        this.templatesLoading = true // abtestmergesearch loading flag.
        this.handleSearchPresentation()
      }
    },

    clearSearch() {
      this.searchText = ''
      this.handleInputChanged()
    },

    async loadMore() {
      if (this.isLoadingMore) return
      this.isLoadingMore = true
      this.handleSearchPresentation()
      utils.gaTrackEvent('Templates', 'Click load more', '')
    },
    async handleOpenModalPublishPresentations() {
      const data = await CommunityApi.getAllNotPublishedPresentation()
      this.notYetPublishPresentations = data.docs || []
      this.numberOfPresentations = data.numberOfPresentations || 0
      this.isModalPublishPresentationsVisible = true
      utils.gaTrackEvent('Template Library', 'Publish to Template Library')
    },
    handleCloseModalPublishPresentations() {
      this.isModalPublishPresentationsVisible = false
    },
    getSliderOptions(category) {
      // return unique options for each slide
      // avoid using prev/next button on 1 slider also triggers the other sliders
      const { folderId: id, folderName } = category
      return {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        noSwiping: false,
        cssMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        spaceBetween: this.isMobile ? 20 : 32,
        navigation: {
          prevEl: `.slider.__prev.--${id}`,
          nextEl: `.slider.__next.--${id}`,
        },
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
          960: {
            slidesPerGroup: 3,
          },
        },
        on: {
          setTranslate: _.debounce((translate) => {
            // hack to track scrolling interactions
            // whenever translate changed, it means slider moved
            // either by 1. clicking or 2. scrolling
            // if button is previously clicked, waiting for translate to change
            if (this.clickingToScroll === null) return // initial load, ignore
            if (this.clickingToScroll) {
              utils.gaTrackEvent(constants.gaCategories.TEMPLATE_LIBRARY, `Templates > Carousel > ${this.clickingToScroll}`, folderName)
              this.clickingToScroll = ''
            } else {
              const direction = translate > this.translate ? 'Left' : 'Right'
              this.translate = translate
              utils.gaTrackEvent(constants.gaCategories.TEMPLATE_LIBRARY, `Templates > Carousel > Swipe ${direction}`, folderName)
            }
          }, 200),
        },
      }
    },
    hidePreviewPopUp() {
      this.previewPopup = false
    },
    updatePublishedTemplateInList(template) {
      this.updateNewlyAddedAfterPublishAction(template)
    },
    trackingSeeAll(eventLabel) {
      utils.gaTrackEvent('Template Library > Listing', 'Template library > See all', eventLabel)
    },
  },
}
</script>

<style lang="scss" scoped>
$thumbnail-ratio: calc(16 / 9);
$card-width: 250px;

@media (max-width: 768px) {
  .input-search-template {
    position: absolute;
    width: 190px;
    right: 0;
    top: 8px;
  }
}

.publish-presentation-btn {
  display: none;
  @media (min-width: 769px) {
    display: inline-flex;
  }
}

.slider {
  &.__slider {
    @apply relative;
    min-height: 220px;
    .slider {
      box-shadow: 0px 0px 10px -3px #888888;
    }
  }

  &.__prev,
  &.__next {
    @apply absolute cursor-pointer bg-base-0 rounded-full w-10 h-10;
    @apply flex justify-center items-center hover:text-primary-100;
    top: 48%;
    z-index: 2;

    &.swiper-button-disabled {
      @apply hidden;
    }
    &.hidden {
      display: none;
    }
  }

  &.__prev {
    left: -20px;
    @media (max-width: 767px) {
      left: -12px;
    }
  }

  &.__next {
    right: -20px;
    @media (max-width: 767px) {
      right: -12px;
    }
  }
}

.swiper-slide {
  width: $card-width;
  padding-bottom: 0.25rem;
  margin-bottom: 1rem;
  &.swiper-slide__template-library{
    width: 357.26px;
  }
}

.title-template-category-container{
  display: flex;
  align-items: baseline;
  .title-item-template-category{
    flex-grow: 1;
  }
  .title-template-see-all{
    flex: none;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;

    color: #348EF6;
  }
}

.template-container_item{
  margin-bottom: -20px;
}

.title-template-type{
  margin-top: 48px;
  margin-bottom: 20px;
  &.title-item-template-category{
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    color: #2F323E;
  }
  display: flex;
  align-items: flex-end;
  font-size: 20px;
  .icon-template-type{
    margin-right: 9px;
    img{
      display: inline-block;
    }
  }
}

.template-library__content-wrapper {
  @apply relative flex flex-col h-full m-4 mt-6 md:px-6;
  .onboarding__arrow {
    @apply top-4 lg:-left-4 -left-8;
  }
  .categories-list{
    margin-bottom: 0;
  }
}

@media (max-width: 1024px) {
  .title-template-see-more {
    margin-top: 4px;
    margin-bottom: 32px;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #348EF6;
  }
  .icon-template-type{
    width: 24px;
    height: 24px;
  }
  .title-template-type{
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #2F323E;
  }

  .template-container_item{
    .template-category-item{
      margin-bottom: 0;
      .swiper-slide{
        margin-bottom: 0;
        .template-card{
          margin-bottom: 20px;
        }
      }
    }
  }

  .title-template-see-more__newly-added{
    margin-bottom: 46px;
  }

  .template-container_item_category{
    .title-template-category-container{
      display: flex;
      justify-content: space-between;
      .title-template-type{
        margin-top:12px;
      }
    }
  }
}

</style>
